import { z } from 'zod';

/**
 * Zod schemas for project-related types
 * These provide runtime validation and type inference
 */

// ProjectPhase schema
export const projectPhaseSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  phaseNumber: z.number().int().positive(),
  title: z.string().min(1, 'Title is required'),
  description: z.string().optional(),
  durationDays: z.number().int().nonnegative(),
  startDate: z.string().optional(),
  targetEndDate: z.string().optional(),
  status: z.enum(['Not Started', 'In Progress', 'Completed', 'Approved', 'Rejected'] as const),
  completedAt: z.string().optional(),
  completedBy: z.string().optional(),
  approvedAt: z.string().optional(),
  approvedBy: z.string().optional(),
  approvalNotes: z.string().optional(),
  rejectedAt: z.string().optional(),
  rejectedBy: z.string().optional(),
  rejectionNotes: z.string().optional(),
  images: z.array(z.string()),
  pmTouchpointDate: z.string().optional(),
  pmTouchpointNotes: z.string().optional(),
  sopId: z.string().optional(),
});

// Infer TypeScript type from schema
export type ProjectPhase = z.infer<typeof projectPhaseSchema>;

// Partial schema for updates
export const projectPhaseUpdateSchema = projectPhaseSchema.partial().required({ id: true });
export type ProjectPhaseUpdate = z.infer<typeof projectPhaseUpdateSchema>;

// ProjectTask schema
export const projectTaskSchema = z.object({
  id: z.string(),
  title: z.string().min(1, 'Task title is required'),
  status: z.enum(['Not Started', 'In Progress', 'Completed', 'Approved', 'Rejected'] as const),
  assignee: z.string().optional(),
  dueDate: z.string().optional(),
  due: z.string().optional(), // Alias for dueDate
  projectId: z.string().optional(),
  phaseId: z.string().optional(),
});

export type ProjectTask = z.infer<typeof projectTaskSchema>;
